import {
	CHILD_REFS_ANALYSE,
	CHILD_REFS_SUCCESS,
	CHILD_REFS_RESET,
	CHILD_REFS_IMPORT,
} from '../constants/patchMenu';

// Résultat de l'analyse d'un établissement : ce qu'il possède et que le siège
// n'a pas. Un seul établissement à la fois — l'analyse est une action ponctuelle
// sur un fils choisi, pas un état permanent du parc.
const initialState = {
	loading: false,
	importing: false,
	// null tant qu'aucune analyse n'a été demandée : distinct d'une analyse qui
	// n'aurait rien trouvé.
	result: null,
};

export default function childRefsReducer(state = initialState, action) {
	switch (action.type) {
		case CHILD_REFS_ANALYSE:
			return { ...state, loading: true, result: null };
		case CHILD_REFS_SUCCESS:
			return { ...state, loading: false, importing: false, result: action.result };
		case CHILD_REFS_IMPORT:
			return { ...state, importing: true };
		case CHILD_REFS_RESET:
			return initialState;
		default:
			return state;
	}
}
